export const mod = (x: number, n: number): number => ((x % n) + n) % n
